import { SERVICES } from "../../lib/data";

export default function Services() {
  return (
    <section id="leistungen" data-testid="services-section" className="py-24 md:py-32 bg-[#F5F2EC]/40">
      <div className="container-x">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10 mb-16 md:mb-24">
          <div className="md:col-span-7 reveal">
            <div className="flex items-center gap-3 mb-6">
              
              <span className="overline">Leistungen</span>
            </div>
            <h2 className="font-display text-5xl md:text-6xl lg:text-7xl leading-[1.02] text-[#1A1A1A] tracking-tight">
              Exzellenz in <br />
              <span className="italic font-light">jedem</span>{" "}
              <span className="gold-text italic">Detail</span>.
            </h2>
          </div>
          <div className="md:col-span-4 md:col-start-9 md:pt-8 reveal">
            <p className="text-[15px] leading-relaxed text-[#5A5A5A] font-light">
              Foto, Video, Drohne, 3D-Touren, Virtual Staging und Bildbearbeitung —
              modular kombinierbar zu einem maß&shy;ge&shy;schnei&shy;derten Content-Paket.
            </p>
          </div>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-px bg-[#EAE6DE] border border-[#EAE6DE]">
          {SERVICES.map((s, idx) => (
            <div
              key={s.num}
              data-testid={`service-card-${s.num}`}
              className={`group relative bg-[#F8F5EF] p-8 md:p-10 transition-colors duration-500 hover:bg-white reveal ${
                idx % 3 === 1 ? "lg:translate-y-6" : ""
              }`}
            >
              <div className="flex items-baseline justify-between">
                <span className="ticker-num text-2xl text-[#1A1A1A]/30 group-hover:text-[#FFA500] transition-colors duration-500">
                  {s.num}
                </span>
                <span className="w-6 h-px bg-[#1A1A1A]/15 group-hover:w-12 group-hover:bg-[#FFA500] transition-all duration-500"></span>
              </div>
              <h3 className="mt-8 font-display text-[26px] md:text-[30px] leading-tight text-[#1A1A1A] tracking-tight">
                {s.title}
              </h3>
              <p className="mt-4 text-[14px] leading-relaxed text-[#5A5A5A] font-light">
                {s.desc}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
